<template>
  <div>
    <div class="flex items-center px-4 py-4 flex-wrap">
      <div class="w-6/12">
        {{ header }}
      </div>
      <div class="w-6/12 justify-end flex"></div>
    </div>

    <div class="w-full flex justify-center py-6 relative">
      <div class="middle-text">
        <div class="w-auto text-center inner-content">
          <b class="w-full block">₦ {{ totalValue }}</b>
          <span class="w-full block opacity-50">Total</span>
        </div>
      </div>
      <apexchart
        type="donut"
        width="380"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: { type: String },
    paymentMethod: { type: Object },
  },

  computed: {
    // chart series: values for the donut
    series() {
      if (!this.paymentMethod) return [0, 0];
      return [
        this.paymentMethod.inApp || 0,
        this.paymentMethod.cashOnDelivery || 0,
      ];
    },

    // labels for each slice
    labels() {
      return ["In-App", "Cash On Delivery"];
    },



    totalValue() {
      if (!this.paymentMethod || this.paymentMethod.total == null) return "0.00";
      const formatter = new Intl.NumberFormat("en-NG", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(Number(this.paymentMethod.total));
    },

    // chart options should be a computed getter
    chartOptions() {
      return {
        chart: {
          width: 380,
          type: "donut",
        },
        colors: ["#D72638", "#09B78A"],
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: true,
                name: { show: false }, // hide slice names
                value: { show: false }, // hide slice values
                total: {
                  show: true,
                  label: "Total",
                  formatter: () => this.totalValue, // reactive total
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 200 },
              legend: { show: false },
            },
          },
        ],
        legend: {
          show: false,
          // position: "bottom",
        },
        labels: this.labels, // now dynamically bound
      };
    },
  },
};
</script>


<style lang="scss" scoped>
.middle-text {
  @apply absolute w-full h-full top-0 left-0 flex justify-center items-center;
}

.inner-content {
  @apply relative;
  top: -16px;
}
</style>
